<h1 mat-dialog-title>{{ data.title | translate }}</h1>

<div mat-dialog-content>
    <p>
        <editable-comments [idPrefix]="idPrefix"
                           [comments]="comments"
                           [readonly]="true">
        </editable-comments>
    </p>
</div>

<div mat-dialog-actions align="center">

    <div class="col-sm-6 offset-sm-6 no-gutters pr-0">
        <button id="{{idPrefix}}btn.close" mat-raised-button class="full-width" *ngIf="data.closeBtnOverride" (click)="close()">{{ data.closeBtnOverride | translate }}</button>
        <button id="{{idPrefix}}btn.close" mat-raised-button class="full-width" *ngIf="!data.closeBtnOverride" (click)="close()">{{ 'common.btn.no' | translate }}</button>
    </div>

</div>
